<router-outlet></router-outlet>
@if(!isLoadingPage()){
    <app-navbar></app-navbar>
    <div class="body-section">
        <app-sidebar></app-sidebar>
        <router-outlet></router-outlet>
    </div>
}@else{
    <router-outlet></router-outlet>
}
